export default "__VITE_ASSET__CcHS4cQl__"